import { createActions, handleActions } from 'redux-actions';

const actions = createActions({
    DOWNLOAD: {
        FETCHING: assetId => ({ assetId }),
        FETCHED: asset => ({ asset }),
    },
});

const initialState = {
    didError: {},
    fetching: {},
    downloadsById: {},
};

export default handleActions(
    {
        [actions.download.fetching]: (state, action) => {
            const { assetId } = action.payload;

            return Object.assign({}, state, {
                fetching: {
                    ...state.fetching,
                    [assetId]: true,
                },
            });
        },

        [actions.download.fetched]: {
            next: (state, action) => {
                const asset = action.payload.asset;
                const currentAssetId = asset.assetId;
                const url = asset.signedUrl || null;

                return Object.assign({}, state, {
                    fetching: Object.keys(
                        state.fetching
                    ).reduce((result, assetId) => {
                        if (assetId !== currentAssetId) {
                            result[assetId] = state.fetching[assetId];
                        }
                        return result;
                    }, {}),
                    downloadsById: Object.assign({}, state.downloadsById, {
                        [currentAssetId]: url,
                    }),
                });
            },
            throw: (state, action) => {
                const currentAssetId = action.payload.assetId;

                return Object.assign({}, state, {
                    didError: {
                        ...state.didError,
                        [currentAssetId]: true,
                    },
                    fetching: Object.keys(
                        state.fetching
                    ).reduce((result, assetId) => {
                        if (assetId !== currentAssetId) {
                            result[assetId] = state.fetching[assetId];
                        }
                        return result;
                    }, {}),
                });
            },
        },
    },
    initialState
);

export const getDownloadUrl = (assetId, newWindow = false) => {
    const windowTab = newWindow ? window.open() : null;

    return (dispatch, getState, api) => {
        dispatch(actions.download.fetching(assetId));

        return api.get(`/assets/${assetId}/download`).then(
            response => {
                dispatch(actions.download.fetched(response.data));

                if (response.data.signedUrl && windowTab) {
                    windowTab.location.href = response.data.signedUrl;
                }
            },
            err => dispatch(actions.download.fetched(err))
        );
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/download.js